import { render, staticRenderFns } from "./FPotensiSpasialMain.vue?vue&type=template&id=5f4569f0&scoped=true"
import script from "./FPotensiSpasialMain.vue?vue&type=script&lang=js"
export * from "./FPotensiSpasialMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4569f0",
  null
  
)

export default component.exports